import * as React from 'react';

const UnMute = ({
  fill = '#212721',
  width = '23',
  height = '18'
}: React.SVGProps<SVGSVGElement>) => (


  <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5008 0.245978C10.682 -0.16344 9.67706 -0.0518039 8.93268 0.506636L4.28035 4.07976H2.23325C1.00504 4.07976 0 5.08473 0 6.31302V11.6726C0 12.9008 1.00497 13.9058 2.23325 13.9058H4.28035L8.93268 17.479C9.37923 17.8139 9.9003 18 10.4213 18C10.7936 18 11.1656 17.9255 11.5005 17.7393C12.3193 17.3299 12.8404 16.474 12.8404 15.5435L12.8406 2.44253C12.8406 1.51207 12.3196 0.655836 11.5008 0.246431L11.5008 0.245978ZM10.6449 15.5429C10.6449 15.58 10.6449 15.6545 10.5332 15.729C10.4587 15.7661 10.3845 15.7661 10.31 15.6919L5.35988 11.9327C5.17373 11.7839 4.91334 11.7094 4.69008 11.7094L2.271 11.6723L2.30812 6.3127H4.7272C4.98786 6.3127 5.21113 6.23819 5.39701 6.08943L10.3471 2.29306C10.3842 2.25594 10.4587 2.21855 10.5704 2.25594C10.682 2.33045 10.682 2.4047 10.682 2.44208V15.5431L10.6449 15.5429Z" fill="#00AEC7" />
  </svg>


);

export default UnMute;
